Foundation.Twitter.Authenticator = function () {
  this._fdnMember = null
  this._twitterUser = null
}

Foundation.Twitter.Authenticator.prototype.sessionManagerDelegateID = function () {
  return "twitter";
}

Foundation.Twitter.Authenticator.prototype.serviceName = function () {
  return "Twitter";
}

Foundation.Twitter.Authenticator.prototype.authenticateWithThirdPartyService = function () {
  //if(window.console) console.log('Foundation.Twitter.Authenticator.authenticateWithThirdPartyService')
  var result = new Foundation.Promise()
  var popWidth = 600
  var popHeight = 400
  var popLeftPos = Math.max(parseInt((window.innerWidth - popWidth) / 2), 0)
  var popTopPos = Math.max(parseInt((window.innerHeight - popHeight) / 2), 0)
  var popSpecs = `width=${popWidth},height=${popHeight},left=${popLeftPos},top=${popTopPos}`
  var pop = window.open('', '_blank', popSpecs);
  var getRequestToken = new Foundation.API("GET", "Twitter/Member", {
    "request": "getRequestToken"
  })
  getRequestToken.then(function () {
    pop.location = `https://api.twitter.com/oauth/authenticate?oauth_token=${getRequestToken.get("oauth_token")}`
    Foundation.Twitter.Authenticator.signInWindow = new Foundation.Observable()
    Foundation.Twitter.Authenticator.signInWindow.observe("fulfill", function () {
      var twitterDeets = new Foundation.API("GET", "Twitter/Member", {
        "request": "twitterDeets"
      })
      twitterDeets.then(function () {
        this._twitterUser = {
          "email": twitterDeets.get("email"),
          "name": twitterDeets.get("name"),
          "screen_name": twitterDeets.get("screen_name")
        }
        Foundation.Twitter.Authenticator.signInWindow.unobserveAll()
        result.fulfill()
      }.bind(this), function () {
        Foundation.Twitter.Authenticator.signInWindow.unobserveAll()
        result.fail()
      }.bind(this))
    }.bind(this))
    Foundation.Twitter.Authenticator.signInWindow.observe("fail", function () {
      Foundation.Twitter.Authenticator.signInWindow.unobserveAll()
      result.fail()
    }.bind(this))
  }.bind(this), function () {
    result.fail()
  }.bind(this))
  return result
}

Foundation.Twitter.Authenticator.prototype.sessionTTL = function () {
  return 0
}

Foundation.Twitter.Authenticator.prototype.suggestedUserEmailAddress = function () {
  return this._twitterUser.email || null
}

Foundation.Twitter.Authenticator.prototype.suggestedUserName = function () {
  return this._twitterUser.screen_name || null
}

Foundation.Twitter.Authenticator.prototype.suggestedUserFullName = function () {
  return this._twitterUser.name || null
}

Foundation.Twitter.Authenticator.prototype.authenticateWithFoundation = function () {
  //if(window.console) console.log('Foundation.Twitter.Authenticator.authenticateWithFoundation')
  var result = new Foundation.Promise()
  this._fdnMember = new Foundation.API("GET", "Twitter/Member", {
    "request": "memberAuth"
  })
  this._fdnMember.then(function () {
    if (this._fdnMember.get("isLikelyToCollide")) {
          return result.fail()
    }
    else {
      result.marry(this._fdnMember)
    }
  }.bind(this), function () {
    result.marry(this._fdnMember)
  }.bind(this))
  return result
}

Foundation.Twitter.Authenticator.prototype.decorateMember = function (/* theMember */) {
  var done = new Foundation.Promise()
  done.fulfill()  // Nothing to do here
  return done
}

Foundation.Twitter.Authenticator.prototype.memberOid = function () {
  return (this._fdnMember.get("oid"))
}

Foundation.Twitter.Authenticator.prototype.memberUserName = function () {
  return (this._fdnMember.get("userName"))
}

Foundation.Twitter.Authenticator.prototype.memberAvatarUrl = function () {
  return (new Foundation.Cookie("foundation-twitter-avatar")).getValue() || (new Foundation.Cookie("foundation-avatarUrl")).getValue()
}

Foundation.Twitter.Authenticator.prototype.accountIsLikelyToCollide = function () {
  return (this._fdnMember.get("isLikelyToCollide")) || false
}

Foundation.Twitter.Authenticator.prototype.linkLoggedInMemberWithThirdPartyCredentials = function () {
  //if(window.console) console.log('Foundation.Twitter.Authenticator.linkLoggedInMemberWithThirdPartyCredentials')
  var result = new Foundation.Promise()
  var si = new Foundation.Session.Manager.sharedInstance()
  if (si.isAuthenticated()) {
    this._fdnMember = new Foundation.API("POST", "Twitter/Member", {
      "request": "linkTwitterUser"
    })
  }
  else {
    //if(window.console) console.log('Account not linked with Twitter.')
    result.failWith({"errors": [Foundation.Twitter.Authenticator._notLoggedInErrorMessage]})
  }
  return result
}

Foundation.Twitter.Authenticator.prototype.userCanceledAccountCreation = function () {
  //if(window.console) console.log('Foundation.Twitter.Authenticator.userCanceledAccountCreation')
  return Foundation.Twitter.cleanCookie()
}

Foundation.Twitter.Authenticator._notLoggedInErrorMessage = "User does not appear to be logged in with Twitter and connected to publication account."

// ---------------------------------------------------------------------

window["Foundation"]["Twitter"]["Authenticator"] = Foundation.Twitter.Authenticator
window['Foundation']['Twitter']['Authenticator']['signInWindow'] = Foundation.Twitter.Authenticator.signInWindow

// ---------------------------------------------------------------------
